function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import { setColor } from '../../../helpers/styleUtils';
export const FileDropHintCover = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  text-align: center;
  border-radius: .2rem;
  background: ${setColor.outerSpace};
  opacity: 0.8;
`;
export const FileDropHintSpan = styled.span`
  font-size: 20px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class FileDropHint extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(FileDropHintCover, {
        className: 'file-drop-hint',
        style: {
          display: this.props.show ? 'block' : 'none'
        }
      }, /*#__PURE__*/React.createElement(FileDropHintSpan, null, this.props.hint || 'Drop Files Here'));
    });
  }

}

export default FileDropHint;